module.exports = "<lemsar-header-container [scrolled]=\"true\">\n    <router-outlet></router-outlet>\n    <lemsar-footer></lemsar-footer>\n</lemsar-header-container>\n"


//////////////////
// WEBPACK FOOTER
// ./apps/frontend/src/template/default/pages/default.page.html
// module id = ./apps/frontend/src/template/default/pages/default.page.html
// module chunks = main